import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useIsEmbed } from '@aftersale-next/atoms';
import { EcommerceLogo, When } from '@aftersale-next/ui';
import React from 'react';
import { PageContent } from './page-content';

var BasicPageLayout = function BasicPageLayout(_ref) {
  var children = _ref.children;

  var _useIsEmbed = useIsEmbed(),
      _useIsEmbed2 = _slicedToArray(_useIsEmbed, 1),
      isEmbed = _useIsEmbed2[0];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(When, {
      value: !isEmbed,
      children: /*#__PURE__*/_jsx(EcommerceLogo, {})
    }), /*#__PURE__*/_jsx(PageContent, {
      children: children
    })]
  });
};

export default BasicPageLayout;